import { render, staticRenderFns } from "./loading-bar.vue?vue&type=template&id=49494c5a&"
import script from "./loading-bar.vue?vue&type=script&lang=js&"
export * from "./loading-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49494c5a')) {
      api.createRecord('49494c5a', component.options)
    } else {
      api.reload('49494c5a', component.options)
    }
    module.hot.accept("./loading-bar.vue?vue&type=template&id=49494c5a&", function () {
      api.rerender('49494c5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loadingbar/loading-bar.vue"
export default component.exports